// Dev-only diagnostics; silent in production builds (swap for an error-reporting service when one is adopted).
const enabled = process.env.NODE_ENV !== "production";
export const log = {
  warn: (...a) => { if (enabled) console.warn(...a); },
  error: (...a) => { if (enabled) console.error(...a); },
};
